import React from 'react';
import superagent from 'superagent';
import { fromUnixTime, formatDistanceToNow, format } from "date-fns";
import { formatInTimeZone } from 'date-fns-tz'
import {formatPrice}  from '../Util/formatters';

import MoviesTVWrapper from './MoviesTVWrapper.jsx';

import {
    Container,
    Segment,
    Grid,
    Header,
    Image,
    Icon,
    Button,
    Table,
    Form,
    Label,
    Message,
    Menu,
    Tab,
    Dropdown,
    Modal,
    Card, 
    Divider} from 'semantic-ui-react'
import { DEFAULT_TIMEZONE } from '../CloudApi/Constants.js';

export default class MediaProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            originalProducts: [],
            currentProducts: [],
            showCloneDialog: false,
            productToClone: null,
            entitlementClasses: {},
            
            cloneOptions: {
                overrideEntitlementClass: null,
                clonePricing: true
            }
        };
    }

    async componentDidMount() {
        this.setState({ loading: true });
        const res = await superagent.get(`/api/admin/media/products`).accept('json');
        this.setState({ originalProducts: res.body, currentProducts: res.body });

        const schemaRes = await superagent.get("/api/admin/media/schemas");
        const entitlementClasses = Object.keys(schemaRes.body.EntitlementClass).map(k => { return { "key": k, "value": k, "text": k } });
        this.setState({ entitlementClasses, loading: false });
    }

    onSearch(e, { name, value }) {
        e.preventDefault();
        if (value.length >= 1) {
            const currentProducts = this.state.originalProducts.filter(product => _.toLower(product.title).includes(_.toLower(value)));
            this.setState({ currentProducts });
        } else {
            if (this.state.currentProducts.length !== this.state.originalProducts.length) {
                this.setState({ currentProducts: this.state.originalProducts });
            }
        }
    }

    onSorted(clickedColumn) {
        const { currentProducts, sortDirection } = this.state;
        const newSortDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';
        const sortedProducts = _.sortBy(currentProducts, [clickedColumn]);
        if (newSortDirection === "descending") {
            sortedProducts.reverse();
        }
        this.setState({
            currentProducts: sortedProducts,
            sortDirection: newSortDirection
        });
    }

    async onCloneOptionsChange(e, { name, value }) {
        const cloneOptions = this.state.cloneOptions;
        cloneOptions[name] = value;
        this.setState({ cloneOptions });
    }

    // Clone account dialog
    onClone(e) {
        e.preventDefault();
        this.setState({showCloneDialog: true });
    }

    closeCloneModal(e) {
        this.setState({showCloneDialog: false});
    }

    async onConfirmClone(e) {
        e.preventDefault();
        this.setState({ loading: true });
        try {
            // superagent doesn't support copy?
            const result = await superagent.post(`/api/admin/media/clone_product/${this.state.productToClone.id}`).accept('json').send(this.state.cloneOptions);
            this.props.history.push({pathname: `/cinema/product/${result.body.id}`});
        } catch (e) {
            console.log(e);
        }
        this.setState({showCloneDialog: false});
    }

    onCloneProduct(product) {
        this.setState({ 
            productToClone: product,
            cloneOptions: {
                overrideEntitlementClass: product.entitlementClass,
                clonePricing: true
            },
            showCloneDialog: true
        });
    }

    render() {
        const title = this.state.loading ? "" : `All Media Products (${this.state.originalProducts.length})`;
        return (
            <MoviesTVWrapper loading={this.state.loading} title={title}>
                <Modal dimmer="inverted" closeOnEscape={true} closeOnDimmerClick={true} closeIcon
                    centered={false}
                    onClose={this.closeCloneModal.bind(this)}
                    open={this.state.showCloneDialog}>
                    <Header icon='clone' content={`Clone ${this.state.productToClone ? this.state.productToClone.title : ""}`} />
                    <Modal.Content>
                        {
                            (this.state.productToClone) &&
                            <Header as='h4' image>
                                <Image src={this.state.productToClone.marketingData["en-US"].unityPosterTexture 
                                    && this.state.productToClone.marketingData["en-US"].unityPosterTexture["src"]} size="medium" />
                                {this.state.productToClone.title}
                            </Header>
                        }
                        <Form>
                            <Form.Group>
                                <Form.Select readOnly={this.state.productToClone !== null}
                                    inline
                                    width={12}
                                    label='Set a different entitlement Class'
                                    name="overrideEntitlementClass"
                                    value={this.state.cloneOptions.overrideEntitlementClass}
                                    options={this.state.entitlementClasses}
                                    onChange={this.onCloneOptionsChange.bind(this)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Field label="Clone Pricing Information (Stripe?)"></Form.Field>
                                <Form.Checkbox checked={this.state.cloneOptions.clonePricing} name="clonePricing" onChange={this.onCloneOptionsChange.bind(this)} />
                                
                                
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeCloneModal.bind(this)}>
                            Cancel
                        </Button>
                        <Button color='green' positive onClick={this.onConfirmClone.bind(this)} loading={this.state.loading}>
                            <Icon name='clone' />Clone it!!!
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Form>
                    <Form.Group inline>
                        <Form.Input widths={4} autoComplete="off"  icon="search" label='Search' placeholder='Search' 
                            name="search" onChange={this.onSearch.bind(this)} />
                        <Button primary href={`/cinema/product`}>Create a media product</Button>
                    </Form.Group>
                </Form>
                
                <Table compact celled sortable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "title")} width={3}>Title</Table.HeaderCell>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "status")} width={1}>Store Link</Table.HeaderCell>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "bigMediaId")} width={1}>BigMediaId</Table.HeaderCell>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "duration")} width={1}>Duration</Table.HeaderCell>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "synchronizationInterval")} width={1}>Synchronization Interval</Table.HeaderCell>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "entitlementClass")} width={1}>Entitlement Class</Table.HeaderCell>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "createdAt._seconds")} width={1}>Created</Table.HeaderCell>
                        <Table.HeaderCell onClick={this.onSorted.bind(this, "locationCodes.length")}>Locations and SKUs</Table.HeaderCell>
                        <Table.HeaderCell width={1}>Tools</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>

                {this.state.currentProducts.map(product => {
                    const locationCodes = product.locationCodes ? (
                        <div>
                        {product.locationCodes.map(locationCode => (
                            <Label color="blue">{locationCode}</Label>
                        ))}
                        </div>
                    ) : <div />;

                    const prices = (
                        <div>
                        {product.stripeProductData && product.stripeProductData.skus && product.stripeProductData.skus.data.map(sku => (
                            <Label color="green">{sku.currency}{formatPrice(sku.currency, sku.price)}</Label>
                        ))}
                        </div>
                    );

                    const createdAt = formatInTimeZone(fromUnixTime(product.createdAt._seconds), DEFAULT_TIMEZONE, 'PPPp z');
                    const tempDuration = product.duration || 0;
                    const hours = Math.floor(tempDuration / 3600000);
                    const minutes = ((tempDuration - (hours * 3600000)) / 60000).toFixed(0);
                    const duration = hours > 0 ? hours + "hr " + minutes + "min" : minutes + "min";
                    
                    return (
                        <Table.Row key={product.id}>
                            <Table.Cell width={3}>
                                <Header as='h4' image>
                                    <Image src={product.marketingData["en-US"].unityPosterTexture && product.marketingData["en-US"].unityPosterTexture["src"]} size="medium" />
                                    {product.title}
                                </Header>
                            </Table.Cell>
                            <Table.Cell width={1}>
                                {
                                    product.status === "ACTIVATED" 
                                    ? <a href={`/cinema/${product.bigMediaId}/${product.url}`} target="_new">Store</a> 
                                    : <Label color="red">{product.status}</Label>
                                }
                            </Table.Cell>
                            <Table.Cell width={1}>
                                {product.bigMediaId}
                            </Table.Cell>
                            <Table.Cell width={1}>
                                <Label>{duration}</Label>
                            </Table.Cell>
                            <Table.Cell width={1}>
                                <Label>{product.synchronizationInterval} mins</Label>
                            </Table.Cell>
                            <Table.Cell width={1}>
                                <Label>{product.entitlementClass}</Label>
                            </Table.Cell>
                            <Table.Cell width={1}>
                                {createdAt}
                            </Table.Cell>
                            <Table.Cell>
                                {locationCodes}<br />
                                {prices}
                            </Table.Cell>
                            <Table.Cell>
                                <Button color="blue" href={`/cinema/product/${product.id}`}>Edit</Button>
                                <Button color="orange" icon="clone" onClick={this.onCloneProduct.bind(this, product)}>Clone</Button>
                            </Table.Cell>
                        </Table.Row>
                    );
                })}
                    </Table.Body>
                </Table>
            </MoviesTVWrapper>
        );
    }
}
